module.exports = __webpack_public_path__ + "img/LV.a64d227f.svg";